<div class="container">
  <div class="cont-min-height">
  <form [formGroup]="roleAssignForm" (ngSubmit)="userRolePermission()">
    <div class="form-row">
      <h6><b>Select the role and the company under which you wish to assign role for -</b></h6>
    </div>
    <div>
      <div class="form-group col-md-3">
        <mat-label>Company</mat-label>
        <input type="text" pInputText class="form-control" name="companyId" formControlName="companyName">
      </div>
      <ng-container formGroupName="appInfo">
        <div class="form-group col-md-6">
          <mat-label>Apps</mat-label>
          <p-multiSelect overlayVisible="true" formControlName="selectedAppIds" defaultLabel="Select app(s)" class="set-multiselect"
            [options]="appList" optionLabel="application.name" display="chip"
            (onChange)="onSelectionChange($event)"></p-multiSelect>
        </div>
        <div *ngIf="getSelectedRolesPermission()?.length > 0">
          <ng-container formArrayName="selectedRolesPermission">
            <ng-container *ngFor="let item of getSelectedRolesPermission();trackBy: trackByIdFn; let i = index;">
              <div class="px-3 mb-4 clearfix" [formGroupName]="i">
                <label class="roleRadBtnLabel role-radio-title w-100 mb-3">{{getAppName(i)}}</label>
                <div *ngFor="let role of getRoleList(i);" class="w-200px float-left clearfix">
                  <input type="radio" class="switch-role-radio-style" [id]="'roleId_' + i" formControlName="roleId"
                    [value]="role.roleId" (change)="handleRoleChange(role,i)">
                  <label class="roleRadBtnLabel">{{role.roleName}}</label>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </form>
  <div class="row my-3">
    <h6 class="ml-2"><b>Roles for the selected Apps({{selectedApps?.length}})</b></h6>
  </div>
  <div class="container-fluid position-relative" *ngIf="selectedApps?.length > 0">
    <div class="bg-blue-absolute">
    </div>
    <div class="clearfix horizontal-scroll-wrapper">
      <div class="float-left">
        <div class="comp-role-perm-col bg-role-table-header">
          <div class="comp-role-perm-col-title role-permissions-word-break">{{companyName}}</div>
        </div>
      </div>
      <div class="float-left" *ngFor="let app of selectedApps">
        <div class="comp-role-perm-col bg-role-table-header">
          <div class="comp-role-perm-col-title mb-2 role-permissions-word-break">{{app?.appName}}</div>
          <div class="clearfix">
            <input type="radio" class="switch-role-radio-style" name="radiogroup{{app?.id}}"
              [checked]="app.isAppDefault" [value]="app.isAppDefault" (change)="handleDefault(app)">
            <label class="roleRadBtnLabel">Make As Default</label>
          </div>
        </div>
        <div class="comp-role-perm-col">
          <div class="comp-role-perm-col-title mb-2 role-permissions-word-break">{{app?.roleName | uppercase}}</div>
          <h6>Permissions Defined</h6>
          <div class="role-permissions-word-break" *ngFor="let permission of app['listPermissions']">
            {{permission?.name}}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex flex-row-reverse">
    <button type="submit" class="im-btn btn-primary im-btn-md " (click)="onSave()" mat-button>
      Save
    </button>
  </div>
  </div>
</div>
